import styled from 'styled-components';

interface IContainerProps {
    padding?: string;
    minWidthButton?: string;
    minWidthMenu?: string;
}

export const Container = styled.div<IContainerProps>`
    button {
        background-color: transparent!important;
        border: none;
        color: #717171;
        padding: ${props => props.padding || '0.375rem 0.75rem'};
        min-width: ${props => props.minWidthButton || '0px'}!important;

        &:hover {
            background-color: transparent!important;
            border: none;
            color: #717171!important;
            box-shadow: none!important;
        }
    }

    & .btn-primary:focus,
    & .btn-primary:active,
    & .show > .btn-primary.dropdown-toggle,
    & .show > .btn-primary.dropdown-toggle:focus {
        background-color: transparent!important;
        border: none;
        color: #717171!important;
        box-shadow: none!important;
    }

    & .dropdown-menu {
        min-width: ${props => props.minWidthMenu || '10rem'};
    }
`

export const DefaultContainer = styled.div<IContainerProps>`
    button {
        padding: ${props => props.padding || 'auto'};
        min-width: ${props => props.minWidthButton || '0px'};
    }

    & .dropdown-menu {
        min-width: ${props => props.minWidthMenu || '10rem'};
    }
`